import {Routes} from '@angular/router';
import {authGuard} from './auth.guard';
import {ShellComponent} from './shell/shell.component';
import {NycSyncPageComponent} from './features/nyc-sync/nyc-sync-page.component';
import {UsersPageComponent} from './features/users/users-page.component';
import {MonitoringPageComponent} from './features/monitoring/monitoring-page.component';
import {UserPageComponent} from './features/users/user-page.component';
import {SendTextMessagePageComponent} from './features/users/send-text-message-page.component';
import {SupportEmailPageComponent} from './features/support-email/support-email-page.component';
import {PastEmailsPageComponent} from './features/support-email/past-emails-page.component';

export const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'nyc-sync',
      },
      {
        path: 'nyc-sync',
        component: NycSyncPageComponent,
        title: 'NYC Sync',
      },
      {
        path: 'users',
        component: UsersPageComponent,
        title: 'Users',
      },
      {
        path: 'monitoring',
        component: MonitoringPageComponent,
        title: 'Monitoring',
      },
      {
        path: 'support-email',
        component: SupportEmailPageComponent,
        title: 'Support email',
      },
      {
        path: 'support-email/past-emails',
        component: PastEmailsPageComponent,
        title: 'Past support emails',
      },
      {
        path: 'users/:userId',
        component: UserPageComponent,
        title: 'User',
      },
      {
        path: 'users/:userId/send-text-message',
        component: SendTextMessagePageComponent,
        title: 'Send text message',
      },
    ],
  },
  {
    path: 'callback',
    redirectTo: '',
  },
];
